// The profile guide opens by itself the first time anybody opens a profile;
// once closed, only the "?" button in the profile header opens it. Set a date
// here ('YYYY-MM-DD') to stop it opening by itself after that day.
export const PROFILE_GUIDE_AUTO_UNTIL = null;

// Server-side keys (USER_GUIDE_KEYS on the server), one per profile.
export const PROFILE_GUIDES = {
  employee: 'profile.employee',
  company: 'profile.company',
};

// What each step points at; a step whose element is not on the page for this
// role is skipped.
export const TOUR_TARGETS = {
  header: '[data-tour="profile-header"]',
  actions: '[data-tour="profile-actions"]',
  tiles: '[data-tour="profile-tiles"]',
  alert: '[data-tour="profile-tile-alert"]',
  middle: '[data-tour="profile-middle"]',
  collapse: '[data-tour="profile-collapse"]',
  panel: '[data-tour="profile-panel"]',
  edit: '[data-tour="profile-edit"]',
  save: '[data-tour="profile-save"]',
  dirty: '[data-tour="profile-tiles"] button[aria-pressed="true"]',
  help: '[data-tour="profile-help"]',
  contact: '[data-tour="contact-us"]',
};

// Same order on both profiles; the texts differ where the profiles do.
export const PROFILE_GUIDE_STEPS = [
  'header',
  'actions',
  'tiles',
  'alert',
  'middle',
  'collapse',
  'panel',
  'edit',
  'save',
  'dirty',
  'help',
  'contact',
];

// Steps shown with the open tile in edit mode: the guide opens it and closes it
// again (nothing is changed or saved).
export const EDIT_STEPS = ['save', 'dirty'];
